<template>
  <div :class="label ? 'form-group has-label' : ''">
    <label v-if="label">{{ label }}</label>
    <input v-if="disabled"  type="text" class="form-control" :value="value" @input="value = $event.target.value" disabled>
    <input v-else  type="text" class="form-control" :value="value" @input="value = $event.target.value">
  </div>
</template>

<script>
export default {
  props: ['price', 'label', 'disabled'],
  computed: {
    value: {
      get () {
        if(this.price !== 0) {
          return this.$options.filters.priceFromCent(this.price)
        } else {
          return this.price
        }
      },
      set (val) {
        const price = parseInt(parseFloat(val.replace(',', '.') * 100).toFixed(2))
        this.$emit('input', price)
      }
    }
  }
}
</script>
